export default __webpack_public_path__ + "static/media/complementary--turn-right--g2.4b154bb3.png";